import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo } from 'react';
import { createUseStyles, useTheme, Modal as ModalComponent, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../../lib/Web5Context";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'Modal');
const Modal = props => {
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const theme = useTheme();
  const modalProps = useMemo(() => _objectSpread(_objectSpread({}, props), {}, {
    title: props !== null && props !== void 0 && props.description ? /*#__PURE__*/React.createElement("div", {
      className: classes.header
    }, /*#__PURE__*/React.createElement(Text, {
      type: "h6"
    }, props === null || props === void 0 ? void 0 : props.title), /*#__PURE__*/React.createElement(Text, {
      type: "subtitle1"
    }, props === null || props === void 0 ? void 0 : props.description)) : props === null || props === void 0 ? void 0 : props.title,
    cancelText: (props === null || props === void 0 ? void 0 : props.cancelText) || t('action_cancel'),
    confirmText: (props === null || props === void 0 ? void 0 : props.confirmText) || t('action_save'),
    useAutoWidth: true,
    width: '752px',
    overrides: {
      container: {
        style: {
          backgroundColor: theme.colors.grey[50]
        }
      },
      content: {
        style: {
          backgroundColor: theme.colors.primary.white,
          padding: 16,
          borderRadius: 8
        }
      },
      overlay: {
        style: {
          zIndex: 1001
        }
      },
      preComponent: {
        style: {
          display: 'grid',
          gridAutoFlow: 'row',
          gridGap: 8
        }
      }
    }
  }), [classes.header, props, t, theme]);
  return /*#__PURE__*/React.createElement(ModalComponent, modalProps, props === null || props === void 0 ? void 0 : props.children);
};
export default /*#__PURE__*/memo(Modal);